<template>
  <div class="table-region" v-loading="tableLoading">
    <el-table size="small" :data="tableData">
      <el-table-column v-for="col in columns" :key="col.prop" :label="col.label" :prop="col.prop" align="center"
        :min-width="col.minWidth" :show-overflow-tooltip="col.showOverflowTooltip">
        <template slot-scope="scope">
          <span :style="col.showOverflowTooltip ? 'cursor: pointer;' : ''">
            {{ (scope.row[col.prop] || scope.row[col.prop] === 0) ? scope.row[col.prop] : '--' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="150" class-name="small-padding fixed-width"
        v-if="actions && actions.length > 0">
        <template slot-scope="scope">
          <template v-for="(btn, index) in actions">
            <el-button size="small" :type="btn.type || 'text'" @click="handleAction(btn.value, scope.row)"
              v-if="btn.show ? btn.show(scope.row) : true" :key="index">
              {{ btn.label }}
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ListTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleAction(action, row) {
      this.$emit('action', action, row)
    },
  }
}
</script>

<style scoped lang="scss"></style>
